var _defs, _rect, _rect2, _polyline;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirmwareUpgrade({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ee983c;\n      }\n\n      .cls-2 {\n        fill: #3c5ba9;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2.86,
    y: 19.71,
    width: 58.28,
    height: 33.68,
    rx: 3.47,
    ry: 3.47
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 28.24,
    y: 29.69,
    width: 7.32,
    height: 21.63
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "31.95 21.77 23.09 34.23 40.7 33.94"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirmwareUpgrade);
export default __webpack_public_path__ + "static/media/firmwareUpgrade.95ae207489027353cd9a0bb023cacc5b.svg";
export { ForwardRef as ReactComponent };